export const HOMEPAGE_CONTENT = {
  heroSection: {
    headText: 'Simplifying Education For you',
    text: 'Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up.',
  },
  sectionTwo: {
    headText: 'Digitalizing Schooling Experience',
    subText:
      'Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up.',
    digitalizing: [
      {
        img: 'https://res.cloudinary.com/intuneteq/image/upload/v1673341463/Link-park-v2/342_teacher_outline_ztilts.png',
        head: 'Improving Schooling Experience',
        text: 'Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up.',
      },
      {
        img: 'https://res.cloudinary.com/intuneteq/image/upload/v1673341511/Link-park-v2/447_reading_a_book_outline_g1injd.png',
        head: 'Easy to use and understand',
        text: 'Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up.',
      },
      {
        img: 'https://res.cloudinary.com/intuneteq/image/upload/v1673341523/Link-park-v2/14_book_lover_outline_qheyt5.png',
        head: 'Enjoy Class Anywhere',
        text: 'Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up.',
      },
    ],
  },

  sectionThree: {
    headText: 'How it Works',
    subText:
      'Below are the steps you can take to navigate around our site to get started',
    register: {
      headText: 'Register/Sign In',
      subText:
        'Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up. Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up.',
      img: 'https://res.cloudinary.com/intuneteq/image/upload/v1673344016/Link-park-v2/MBP_Mockup_1_ayvmx0.png',
      arrow:
        'https://res.cloudinary.com/intuneteq/image/upload/v1673345502/Link-park-v2/Vector_40_uhew1g.png',
    },
    monitor: {
      headText: 'Monitor Students Activities',
      subText:
        'Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up. Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up.',
      img: 'https://res.cloudinary.com/intuneteq/image/upload/v1673345122/Link-park-v2/MBP_Mockup_2_tj9zaj.png',
      arrow:
        'https://res.cloudinary.com/intuneteq/image/upload/v1673346095/Link-park-v2/Vector_41_m6xajf.png',
    },
    notification: {
      headText: 'Receive Daily Notifications',
      subText:
        'Bringing school to you anywhere and anytime, using resources provided by teachers and permitting parents follow up. Bringing school to you anywhere and anytime, using resources provided by eachers and permitting parents follow up.',
      img: 'https://res.cloudinary.com/intuneteq/image/upload/v1673344016/Link-park-v2/MBP_Mockup_1_ayvmx0.png',
      arrow: '',
    },
  },

  sectionFour: {
    headText: 'Our Achievements',
    achievements: [
      {
        figure: '250+',
        text: 'Schools are registered across the nation.',
      },
      {
        figure: '85%+',
        text: 'Increase in productivity level of students',
      },
      {
        figure: '2000+',
        text: 'School students are registered',
      },
      {
        figure: '1500+',
        text: 'Parents endorse this learning plaform',
      },
    ],
  },
  sectionFive: {
    subText:
      'With simplified medium, upload learning resources and track all of your students learning process.',
  },
  sectionSix: {
    headText: 'Have a walk around our site',
    subText: 'Link up with your school and enjoy class from anywhere.',
    dot1: 'https://res.cloudinary.com/intuneteq/image/upload/v1673348911/Link-park-v2/Group_15903_nwxj4p.png',
    dot2: 'https://res.cloudinary.com/intuneteq/image/upload/v1673348911/Link-park-v2/Group_15903_nwxj4p.png',
    video:
      'https://res.cloudinary.com/intuneteq/image/upload/v1673348742/Link-park-v2/Group_15904_fvlbmd.png',
  },
}
